module.exports = __webpack_public_path__ + "img/discover.648309be.svg";